import React, { useEffect, useState } from 'react';
import { Modal, Button, Card } from 'react-bootstrap';
import { k3docService } from '../../services';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { BsCircleFill } from 'react-icons/bs';

const timelineDotSize = 18;

const NewVersionNotification = () => {
  const [show, setShow] = useState(false);
  const [versions, setVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState(null);

  useEffect(() => {
    const fetchVersions = async () => {
      try {
        const response = await k3docService.getK3DocVersions('VERSION_FEATURE_PLAN');
        if (response.data.data && response.data.data.length > 0) {
          setVersions(response.data.data.reverse());
        }
      } catch (error) {
        console.error('Error fetching versions:', error);
      }
    };
    fetchVersions();
  }, []);

  const handleClose = () => {
    setShow(false);
    setSelectedVersion(null);
  };

  const handleVersionClick = (version) => {
    setSelectedVersion(version);
    setShow(true);
  };

  if (versions.length === 0) return null;

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      padding: '20px',
      maxWidth: '100%'
    }}>
      <Card className="shadow-sm p-4" style={{ 
        border: 'none', 
        background: 'white',
        width: '800px',
        maxWidth: '100%'
      }}>
        <h4 className="text-center mb-4" style={{ color: '#1976d2', fontWeight: 700 }}>
          Kế Hoạch Phát Triển
        </h4>
        <div style={{ position: 'relative', marginLeft: 32, paddingBottom: 8 }}>
          {/* Timeline vertical line */}
          <div style={{
            position: 'absolute',
            left: 8,
            top: timelineDotSize / 2,
            bottom: 0,
            width: 4,
            background: 'linear-gradient(to bottom, #1976d2 60%, #e3e3e3 100%)',
            borderRadius: 2,
            zIndex: 0
          }} />
          <div>
            {versions.map((version, idx) => {
              const isCurrent = idx === versions.length - 1;
              return (
                <div
                  key={version._id}
                  onClick={() => handleVersionClick(version)}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: 32,
                    cursor: 'pointer',
                    background: isCurrent ? 'rgba(25, 118, 210, 0.07)' : 'transparent',
                    borderRadius: 8,
                    boxShadow: isCurrent ? '0 2px 8px rgba(25,118,210,0.08)' : 'none',
                    transition: 'all 0.2s ease',
                    padding: isCurrent ? '16px 12px' : '8px 12px',
                    borderLeft: isCurrent ? '4px solid #1976d2' : '4px solid transparent',
                  }}
                  onMouseOver={e => {
                    e.currentTarget.style.background = 'rgba(25, 118, 210, 0.13)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseOut={e => {
                    e.currentTarget.style.background = isCurrent ? 'rgba(25, 118, 210, 0.07)' : 'transparent';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  {/* Timeline dot */}
                  <div style={{ marginRight: 24, marginTop: 2, zIndex: 1 }}>
                    <BsCircleFill size={timelineDotSize} color={isCurrent ? '#1976d2' : '#bdbdbd'} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                      <span style={{ fontWeight: 700, fontSize: 18, color: isCurrent ? '#1976d2' : '#222' }}>
                        Version {version.friendly_version}
                      </span>
                      {isCurrent && (
                        <span style={{
                          background: '#1976d2',
                          color: 'white',
                          borderRadius: 4,
                          fontSize: 12,
                          fontWeight: 600,
                          marginLeft: 10,
                          padding: '2px 8px',
                          letterSpacing: 1
                        }}>
                          HIỆN TẠI
                        </span>
                      )}
                    </div>
                    <div style={{ color: '#888', fontSize: 14, marginBottom: 4 }}>
                      {new Date(version.createdAt).toLocaleDateString()}
                    </div>
                    <div style={{ color: '#444', fontSize: 15, fontStyle: 'italic' }}>
                      {version.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Card>

      <Modal show={show} onHide={handleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Version {selectedVersion?.friendly_version}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{selectedVersion?.description}</p>
          <div className="mt-3">
            <h6>Tính năng mới:</h6>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
            >
              {selectedVersion?.content}
            </ReactMarkdown>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NewVersionNotification; 